<template>
  <path
    d="M19.97 19.2002C20.15 20.1602 19.42 21.0002 18.5 21.0002H15.81C14.51 21.0002 13.55 19.7802 13.87 18.5102L15 14.0002H9C7.35 14.0002 6 12.6502 6 11.0002V3.00024H12V9.00024H17C18.1 9.00024 19 9.90024 19 11.0002L17 18.0002H18.44C19.17 18.0002 19.83 18.4902 19.97 19.2002ZM5 12.0002V4.00024C5 3.45024 4.55 3.00024 4 3.00024C3.45 3.00024 3 3.45024 3 4.00024V12.0002C3 14.7602 5.24 17.0002 8 17.0002H11C11.55 17.0002 12 16.5502 12 16.0002C12 15.4502 11.55 15.0002 11 15.0002H8C6.34 15.0002 5 13.6602 5 12.0002Z"
  />
</template>
